export default [
  { label: 'Academy Years', value: 'Academy Years' },
  { label: 'In Uniform', value: 'In Uniform' },
  { label: 'Post Military Life', value: 'Post Military Life' },
  { label: '35th Reunion', value: '35th Reunion' },
  { label: '40th Reunion', value: '40th Reunion' },
  { label: '45th Reunion', value: '45th Reunion' },
  { label: '50th Reunion', value: '50th Reunion' },
  { label: 'ALITC', value: 'ALITC' }
]
